import type { FC } from 'react';
import { Check } from 'lucide-react';
import { TODO_STATUS_CONFIG } from '@/constants/todo.constants';
import type { TodoItemData } from '@/types';

interface TodoItemDisplayProps {
  todo: TodoItemData;
  showHoverEffect?: boolean;
}

const TodoItemDisplay: FC<TodoItemDisplayProps> = ({
  todo,
  showHoverEffect = true,
}) => {
  const config = TODO_STATUS_CONFIG[todo.status] || TODO_STATUS_CONFIG.pending;
  const StatusIcon = config.icon;

  return (
    <div
      className={`flex items-start gap-2 px-3 py-2 rounded-md border border-border bg-background dark:bg-muted/20 transition-all duration-200 theme-transition ${showHoverEffect ? 'hover:bg-muted/50 dark:hover:bg-muted/30' : ''}`}
    >
      <div
        className={`mt-0.5 flex-shrink-0 size-4 rounded border-2 flex items-center justify-center !border-foreground dark:!border-foreground-dark`}
      >
        {todo.status === 'completed' && (
          <Check className="size-2.5 text-foreground dark:text-foreground-dark" />
        )}
      </div>

      <div className="flex-1 min-w-0">
        <div className="flex items-start justify-between gap-2">
          <span
            className={`text-sm font-medium text-foreground dark:text-foreground-dark theme-transition ${todo.status === 'completed' ? 'line-through text-foreground dark:text-foreground-dark' : ''}`}
          >
            {todo.content}
          </span>
          <span
            className={`flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium flex-shrink-0 transition-colors duration-200 ${config.bgColor} ${config.color}`}
          >
            <StatusIcon className="size-2.5" />
            {config.label}
          </span>
        </div>
      </div>
    </div>
  );
};

export default TodoItemDisplay;
